<div class="footer dont-print">
  <div *ngIf="hasLinks && getFooter() && getFooter().length" class="footer-links">
    <div class="footer-column" *ngFor="let footerColumn of getFooter()">
      <div
        *ngFor="let footer of footerColumn"
        [ngSwitch]="isFooterInternal(footer)"
      >
        <a *ngSwitchCase="true" routerLink="/{{clang()}}{{footer.route}}" data-ui-name="Clang    footer route" data-ui-component="footer" data-testid="footer-clang-footer-route"><tra [slug]="footer.caption"></tra></a>
        <a *ngSwitchCase="false" target="_blank" href="{{lang.tra(footer.link)}}" data-ui-name="A" data-ui-component="footer" data-testid="footer-a"><tra [slug]="footer.caption"></tra></a>
      </div>
    </div>
  </div>
  <div class="footer-lower">
      <div class="copyright">
        <tra [slug]="getCopyright()"></tra>
      </div>
      <div>
        <button *ngIf="isAppealShown" [routerLink]="renderAppealLink()" class="footer-comment-link" data-ui-name="File an appeal" data-ui-component="footer" data-testid="footer-file-an-appeal">
          <tra slug="btn_file_an_appeal"></tra>
        </button>
        <span *ngIf="isAppealShown" style="color: #999;margin:0em 0.5em;">•</span>
        <button *ngIf="hasComments" (click)="supportReqActivate()" class="footer-comment-link" data-ui-name="Title feedback" data-ui-component="footer" data-testid="footer-title-feedback">
          <tra whitelabel="tech_support" slug="title_feedback"></tra>
        </button>
      </div>
  </div>
</div>